import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Images/logo1.jpeg";

import { ShoppingCart, User, Menu, X } from "lucide-react";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);

  return (
    <>
      <style>
        {`
          *{
            margin:0;
            padding:0;
            box-sizing:border-box;
          }

          .navbar{
            background:linear-gradient(135deg, #0A2E73 0%, #0d3a94 100%);
            display:flex;
            align-items:center;
            justify-content:space-between;
            padding:14px clamp(16px, 4vw, 40px);
            position:sticky;
            top:0;
            z-index:1000;
            box-shadow:0 4px 15px rgba(0,0,0,0.15);
          }

          /* Left Section */
          .logo-section{
            flex:1;
            display:flex;
            align-items:center;
          }

          .logo-container{
            display:flex;
            align-items:center;
          }

          .logo{
            width:75px;
            height:75px;
            border-radius:50%;
            object-fit:cover;
            border:3px solid #FFD700;
            transition:.4s ease;
            cursor:pointer;
          }

          .logo:hover{
            transform:scale(1.08) rotate(5deg);
            box-shadow:0 0 20px rgba(255,215,0,.5);
          }

          /* Center Section - true centering, independent of side widths */
          .center-section{
            position:absolute;
            left:50%;
            top:50%;
            transform:translate(-50%, -50%);
          }

          .nav-links{
            display:flex;
            align-items:center;
            justify-content:center;
            gap:38px;
            list-style:none;
          }

          .nav-links a{
            color:#fff;
            text-decoration:none;
            font-size:16px;
            font-weight:600;
            letter-spacing:.3px;
            position:relative;
            transition:.3s ease;
            padding:6px 2px;
            white-space:nowrap;
          }

          .nav-links a::after{
            content:"";
            position:absolute;
            left:0;
            bottom:-2px;
            width:0;
            height:2px;
            background:#FFD700;
            border-radius:2px;
            transition:.35s ease;
          }

          .nav-links a:hover{
            color:#FFD700;
          }

          .nav-links a:hover::after{
            width:100%;
          }

          /* Right Section */
          .right-section{
            flex:1;
            display:flex;
            justify-content:flex-end;
            align-items:center;
            gap:14px;
          }

          .icon-btn{
            width:42px;
            height:42px;
            border:none;
            border-radius:50%;
            background:#FFD700;
            color:#0A2E73;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            transition:.3s ease;
          }

          .icon-btn:hover{
            transform:translateY(-3px) scale(1.08);
            box-shadow:0 8px 20px rgba(255,215,0,.4);
          }

          /* Mobile Menu */
          .menu-btn{
            display:none;
            color:#fff;
            cursor:pointer;
            z-index:1100;
            transition:.3s ease;
          }

          .menu-btn:hover{
            color:#FFD700;
          }

          /* Dropdown */
          .dropdown {
            position: relative;
            list-style:none;
          }

          .dropdown-btn {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing:.3px;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 6px 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            white-space:nowrap;
          }

          .dropdown-btn:hover {
            color: #FFD700;
          }

          /* Dropdown Menu */
          .dropdown-content {
            position: absolute;
            top: 55px;
            left: 50%;
            transform: translateX(-50%) translateY(15px);
            min-width: 230px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.2);
            overflow: hidden;
            list-style:none;

            opacity: 0;
            visibility: hidden;

            transition: all 0.35s ease;
            z-index: 999;
          }

          /* Smooth Show - desktop hover only */
          @media(min-width:769px){
            .dropdown:hover .dropdown-content {
              opacity: 1;
              visibility: visible;
              transform: translateX(-50%) translateY(0);
            }

            .dropdown:hover .dropdown-btn {
              color: #FFD700;
            }

            .dropdown:hover .arrow {
              transform: rotate(180deg);
            }
          }

          /* Links */
          .dropdown-content a {
            display: block;
            padding: 14px 22px;
            color: #0A2E73 !important;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.25s ease;
            border-bottom: 1px solid #f1f1f1;
          }

          .dropdown-content a:last-child {
            border-bottom: none;
          }

          .dropdown-content a:hover {
            background: #0A2E73;
            color: #FFD700 !important;
            padding-left: 30px;
          }

          /* Arrow Animation */
          .arrow {
            font-size: 11px;
            transition: transform 0.35s ease;
          }

          .dropdown-btn .arrow.rotate {
            transform: rotate(180deg);
          }

          /* Tablet */
          @media(max-width:992px){

            .nav-links{
              gap:22px;
            }

          }

          /* Mobile */
          @media(max-width:768px){

            .navbar{
              padding:12px 20px;
            }

            .right-section{
              display:none;
            }

            .menu-btn{
              display:block;
            }

            .center-section{
              position:static;
              transform:none;
              width:100%;
            }

            .nav-links{
              position:absolute;
              top:100%;
              left:0;
              width:100%;
              background:#0A2E73;
              flex-direction:column;
              gap:22px;
              padding:25px 0 30px;
              max-height:0;
              overflow:hidden;
              opacity:0;
              visibility:hidden;
              box-shadow:0 10px 20px rgba(0,0,0,.15);
              transition: max-height .4s ease, opacity .3s ease, visibility .3s ease, padding .4s ease;
            }

            .nav-links.active{
              max-height:600px;
              opacity:1;
              visibility:visible;
            }

            .nav-links a{
              font-size:18px;
            }

            /* Dropdown becomes click-controlled, inline (not floating) on mobile */
            .dropdown{
              width:100%;
              display:flex;
              flex-direction:column;
              align-items:center;
            }

            .dropdown-content{
              position:static;
              transform:none;
              width:90%;
              max-width:300px;
              margin-top:10px;
              opacity:0;
              visibility:hidden;
              max-height:0;
              border-radius:12px;
              transition:all 0.35s ease;
            }

            .dropdown-content.show{
              opacity:1;
              visibility:visible;
              max-height:500px;
            }

            .dropdown-content a{
              text-align:center;
            }
          }

          /* Small Mobile */
          @media(max-width:480px){

            .logo{
              width:55px;
              height:55px;
            }

            .nav-links a{
              font-size:16px;
            }

          }
        `}
      </style>

      <nav className="navbar">
        {/* Logo */}
        <div className="logo-section">
          <div className="logo-container">
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={logo} alt="Jaina Enterprises" className="logo" />
            </Link>
          </div>
        </div>

        {/* Center Navigation - perfectly centered regardless of side widths */}
        <div className="center-section">
          <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
            <li><Link to="/resources" onClick={() => setMenuOpen(false)}>Resources</Link></li>

            <li className="dropdown">
              {/* Dropdown Button */}
              <div
                className="dropdown-btn"
                onClick={() => setServiceOpen(!serviceOpen)}
              >
                <span>Scrap Services</span>
                <span className={`arrow ${serviceOpen ? "rotate" : ""}`}>▼</span>
              </div>

              {/* Dropdown Menu */}
              <ul className={`dropdown-content ${serviceOpen ? "show" : ""}`}>
                <li>
                  <Link to="/Scrapservices1" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>All Scrap Services</Link>
                </li>

                <li>
                  <Link to="/IronScrapsection" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>Iron Scrap</Link>
                </li>

                <li>
                  <Link to="/copperScrap" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>Copper Scrap</Link>
                </li>

                <li>
                  <Link to="/AluminiumScrap" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>Aluminium Scrap</Link>
                </li>

                <li>
                  <Link to="/CarScrap" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>Car Scrap</Link>
                </li>

                <li>
                  <Link to="/PlasticScrap" onClick={() => { setMenuOpen(false); setServiceOpen(false); }}>Plastic Scrap</Link>
                </li>
              </ul>
            </li>

            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="right-section">
          <button className="icon-btn">
            <ShoppingCart size={20} />
          </button>

          <button className="icon-btn">
            <User size={20} />
          </button>
        </div>

        {/* Mobile Menu */}
        <div className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </div>
      </nav>
    </>
  );
};

export default Navbar;